import { Dispatch } from 'redux';
import { ActionType } from '../action-types';
import { Action } from '../actions';
import { Installation } from '../../models/microservices';

export const updateKioskInstallation = (installation: Installation) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.UPDATE_KIOSK_INSTALLATION,
      payload: installation,
    });
  };
};
export const kioskDataReset = () => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.KIOSK_DATA_RESET,
    });
  };
};
